// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SmBreadcrumb from "@/components/SmBreadcrumb";
import Ajax from './assets/ajax';
import NewsList from "./assets/newsList.js";

Vue.component('SmBreadcrumb', SmBreadcrumb);

Vue.use(ElementUI);
Vue.prototype.$ajax = Ajax;
Vue.prototype.$newsList = NewsList;
Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
